module.exports = {"540123100":"塔荣镇","540123200":"麻江乡","540123201":"普松乡","540123202":"卡如乡","540123203":"尼木乡","540123204":"续迈乡","540123205":"帕古乡","540123206":"吞巴乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540123.json
// module id = 2486
// module chunks = 0